import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route,Navigate } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import Login from "../auth/Login";
import ApplicationListing from "../components/pages/applicationListing/ApplicationListing"
import UserListing from '../components/pages/userListing/UserListing'
import User from '../components/pages/user/User'
import ResetPassword from "../auth/ResetPassword"
import ForgotPassword from "../auth/ForgotPassword"
import CalqueLoader from "../components/common/CalqueLoader";
import Chatbot from "../components/pages/chatbot/Chatbot";

const ApplicationCreate = lazy(() => import("../components/pages/applicationCreate/ApplicationCreate"));
// const ApplicationListing = lazy(() => import("../components/pages/applicationListing/ApplicationListing"));
// const UserListing = lazy(() => import("../components/pages/userListing/UserListing"));
// const User = lazy(() => import("../components/pages/user/User"));
// const Login = lazy(() => import("../auth/Login"));
// const ResetPassword = lazy(() => import("../auth/ResetPassword"));
// const ForgotPassword = lazy(() => import("../auth/ForgotPassword"));

export default function RouterComponent() {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<PublicRoute> <Login /> </PublicRoute>} />
      <Route path="/application-listing" element={<PrivateRoute><ApplicationListing /></PrivateRoute>} />
      <Route path="/user-listing" element={<PrivateRoute><UserListing /></PrivateRoute>} />
      <Route 
        path="/application-create" 
        element={
          <PrivateRoute>
            <Suspense fallback={<CalqueLoader />}>
              <ApplicationCreate />
            </Suspense>
          </PrivateRoute>
        } 
      />
      <Route path="/user" element={<PrivateRoute><User /></PrivateRoute>} />
      <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
      <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
      {/* <Route path="/calque-ai" element={<PrivateRoute><Chatbot/></PrivateRoute>} />
      <Route path="/calque-ai/:sessionId" element={<PrivateRoute><Chatbot/></PrivateRoute>} /> */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  </Router>
  );
}